module.exports = __webpack_public_path__ + "img/F970.f2402e75.jpg";